import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Layout, Menu, Row, Space } from 'antd';
import { useAuth0 } from '@auth0/auth0-react';
import AuthenticationButton from './auth0/AuthenticationButton';
import logo from '../assets/logo-transparent.png'
import HeaderSelect from './HeaderSelect'
import UserProfile from './auth0/UserProfile';

const styles = {
  layoutHeader: () => ({
    padding: '0 32px',
  }),
  logoDiv: () => ({
    float: 'left',
  }),
  logoText: () => ({
    color: '#fff',
    margin: 0,
    marginRight: '1em',
    display: 'inline',
    width: 100,
    lineHeight: '54px',
  }),
  menu: () => ({
    lineHeight: '64px',
  }),
  user: () => ({
    float: 'right'
  })
}


const Header = ({ location }) => {
  const { isAuthenticated } = useAuth0();

  if (!isAuthenticated) {
    return <></>
  }

  return (
    <Layout.Header
      style={styles.layoutHeader()}
    >
      <div
        style={styles.logoDiv()}
      >
        <img src={logo} style={{ maxWidth: 100, margin: '0px 10px 0px 0px' }} alt="logo" />
        {/* <h2
          style={styles.logoText()}
        >
          Sensika
        </h2> */}
      </div>
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={[location.pathname]}
        style={styles.menu()}
      >
        <Row justify="space-between" wrap={false}>
          <Space direction="horizontal" size={0}>
            <Menu.Item key="/explore" disabled>
              <Link to="/explore">Explore</Link>
            </Menu.Item>
            <Menu.Item key="/">
              <Link to="/">Dashboard</Link>
            </Menu.Item>
          </Space>
          <Space direction="horizontal" size={0}>
            <Menu.Item key="select">
              <HeaderSelect />
            </Menu.Item>
            <Menu.Item key="profile">
              <UserProfile />
            </Menu.Item>
            <Menu.Item key='/auth'>
              <AuthenticationButton />
            </Menu.Item>
          </Space>
        </Row>
      </Menu>
    </Layout.Header>
  )

};

export default withRouter(Header);
